module.exports = __webpack_public_path__ + "static/the-magic-of-reality-31133fd69e80c6fbb3698b516fb0de5f.jpg";